/**
 * Contains the base of the path that determines which app is loaded.
 * This file's location is hard-coded in the app generator. If you need to move it,
 * please update the location of this file in the variable `APP_ROUTES_PATH`
 */
export enum AppRoutes {
  SUPERADMIN = '/sa/',
  ACCOUNT_CENTER = '/account-center/',
  ANALYTICS = '/analytics/',
  LEAD_CENTER = '/lead-center/',
  CABOOSE = '/caboose/',
  CFB = '/cfb/',
  SETTINGS = '/settings/',
  ANUBIS = '/authenticate/',
  MESSENGER = '/messenger/',
  TCW = '/tcw/',
  MFB = '/mfb/',
}

/**
 * Route segments of the Unified Inbox within the analytics app, for in-app
 * router navigation (e.g. `router.navigate([...UNIFIED_INBOX_ROUTE_SEGMENTS])`).
 */
export const UNIFIED_INBOX_ROUTE_SEGMENTS = ['reports', 'unified-inbox'];

/** Path of the Unified Inbox within the analytics app, with a leading slash. */
export const UNIFIED_INBOX_PATH = `/${UNIFIED_INBOX_ROUTE_SEGMENTS.join('/')}`;

/**
 * Full cross-app URL to the Unified Inbox for the given agency, or the analytics
 * app root when no agency id is available.
 */
export function unifiedInboxUrl(agencyId?: number | string): string {
  return agencyId
    ? `${AppRoutes.ANALYTICS}a/${agencyId}${UNIFIED_INBOX_PATH}`
    : AppRoutes.ANALYTICS.slice(0, -1);
}
